/** @jsxImportSource react */
import type { SVGProps } from 'react';
const LegacyEmptyBrokenPencil = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 140 140" {...props}>
    <path
      fill="#EDEEF2"
      d="M19.376 48.607c.11-1.403 1.586-2.275 2.87-1.7 7.799 3.499 31.056 13.229 45.353 11.72 14.275-1.506 35.3-7.507 42.355-9.603a2.013 2.013 0 0 1 2.581 1.795l4.408 63.869a1.96 1.96 0 0 1-1.46 2.052c-6.467 1.667-31.434 7.816-47.884 7.816-16.658 0-44.972-8.552-51.768-10.683a1.98 1.98 0 0 1-1.377-2.045z"
    />
    <path
      fill="#6B7180"
      d="m44.85 91.972 8.256 1.608a1 1 0 0 1 .644 1.531l-.01.016a1 1 0 0 1-.187.212l-1.531 1.302a1 1 0 0 0-.348.85l.121 1.365a1 1 0 0 1-.363.863l-1.657 1.353a1 1 0 0 1-1.486-.253l-4.485-7.344c-.453-.742.192-1.67 1.045-1.503"
    />
    <path
      fill="#CBCFD8"
      d="m59.013 93.546.462-17.906 7.291-1.548c4.83 2.945 14.51 8.811 14.589 8.714s-.278 4.862-.467 7.354c-3.8 2.03-10.771 5.833-13.251 7.187a.985.985 0 0 1-1.362-.43 44 44 0 0 1-.456-.97 1.05 1.05 0 0 0-1.136-.608l-1.29.24a1 1 0 0 1-.96-.356l-.48-.594a1 1 0 0 0-1.157-.297l-.405.165a1 1 0 0 1-1.378-.951"
    />
    <circle cx={56.647} cy={102} r={1} fill="#CBCFD8" />
    <circle cx={62.147} cy={102.5} r={1.5} fill="#CBCFD8" />
    <circle cx={0.5} cy={0.5} r={0.5} fill="#CBCFD8" transform="matrix(1 0 0 -1 58.647 97)" />
    <path
      fill="#E2E4EA"
      d="m64.333 75.774-4.762-.106a.151.151 0 0 1-.125-.23l31.823-52.126a.15.15 0 0 1 .217-.045l20.661 14.665a.15.15 0 0 1 .042.201l-31.15 51.795a.15.15 0 0 1-.276-.038l-1.017-3.782a1 1 0 0 0-.883-.737l-4.51-.377a1 1 0 0 1-.82-.566l-1.652-3.46a1 1 0 0 0-1.085-.552l-3.053.567a1 1 0 0 1-1.126-.652l-1.363-3.888a1 1 0 0 0-.921-.67"
    />
    <path
      stroke="#CBCFD8"
      strokeLinecap="round"
      d="m78.046 54.106-9.874 16.581M103.371 43.608l-10.93 17.208"
    />
    <path
      stroke="#1E2024"
      strokeLinecap="round"
      d="M28.828 117.515s5.981 1.656 11.295 2.932 10.807 2.141 10.807 2.141M26.774 49.14S33.028 52.427 38.678 54s10.871 2.55 10.871 2.55M77.047 92.227s2.933-1.734 3.444-2.437c1.357-1.867 3.695-5.487 3.695-5.487M116.534 107.335s-.904-8.848-1.163-13.045c-.491-7.995-.862-18.61-.862-18.61"
    />
    <path
      fill="#CBCFD8"
      d="M109.716 41.961 90.96 24.018a.15.15 0 0 1-.028-.182l2.144-3.91a3.15 3.15 0 0 1 3.818-1.454l18.528 6.596a3.15 3.15 0 0 1 1.669 4.548l-7.14 12.312a.15.15 0 0 1-.235.033"
    />
    <path stroke="#CBCFD8" strokeLinecap="round" d="m92.44 45.69-20.12 32.6" />
  </svg>
);
export default LegacyEmptyBrokenPencil;
